import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

// Define schema with profile_pic as an optional File
const UserProfileSchema = z.object({
  first_name: StringRequiredSchema('Please enter a first name.'),
  last_name: StringRequiredSchema('Please enter a last name.'),
  position: z.string(),
  position_type: z.number(),
  chargeable_rate: z.number(),
  quals: z.string(),
  address: z.string(),
  suburb: z.string(),
  state: z.string(),
  postcode: z.string(),
  phone_number: z.string(),
  profile_pic: z.instanceof(File).optional().or(z.literal('')),
  signature_pic: z.instanceof(File).optional().or(z.literal('')),
});

export type UserProfileForm = z.infer<typeof UserProfileSchema>;

export const UserProfileDefaultValues: UserProfileForm = {
  first_name: '',
  last_name: '',
  position: '',
  position_type: 0,
  chargeable_rate: 0,
  quals: '',
  address: '',
  suburb: '',
  state: '',
  postcode: '',
  phone_number: '',
  profile_pic: '',
  signature_pic: '',
};

export const useUserProfileForm = () => {
  const form = useForm({
    defaultValues: UserProfileDefaultValues,
    resolver: zodResolver(UserProfileSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
